if (!customElements.get('product-form')) {
  console.log('Registering product-form custom element...');
  // Access product limits configuration from global window object
  // (loaded by product-limits-config.js)
  const productLimitsConfig = window.productLimitsConfig;
  const RESERVATION_AB_TEST_KEY = 'home_reserve_checkout_path_v1';
  const RESERVATION_AB_STORAGE_KEY = 'daisyReservationAbAssignment';

  const getReservationAbMetadata = () => {
    const params = new URLSearchParams(window.location.search);
    const urlVariant = params.get('reservation_ab_variant');
    if (urlVariant) {
      return {
        test: params.get('reservation_ab_test') || RESERVATION_AB_TEST_KEY,
        variant: urlVariant,
        source: window.location.pathname
      };
    }

    try {
      const stored =
        JSON.parse(sessionStorage.getItem(RESERVATION_AB_STORAGE_KEY) || 'null') ||
        JSON.parse(localStorage.getItem(RESERVATION_AB_STORAGE_KEY) || 'null');
      if (stored && stored.test === RESERVATION_AB_TEST_KEY && stored.variant) {
        return {
          test: stored.test,
          variant: stored.variant,
          source: window.location.pathname
        };
      }
    } catch (_error) {
      // Non-critical analytics metadata.
    }

    return null;
  };

  const updateReservationAbCartAttributes = (metadata) => {
    if (!metadata) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          _reservation_ab_test: metadata.test,
          _reservation_ab_variant: metadata.variant,
          _reservation_ab_source: metadata.source
        }
      })
    });
  };

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.handlePageShow = () => this.resetLoadingState();

        console.log('ProductForm constructor - this.cart:', this.cart);
        console.log('cart-notification found:', !!document.querySelector('cart-notification'));
        console.log('cart-drawer found:', !!document.querySelector('cart-drawer'));

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Subscribe to cart updates to keep window.shopifyCart in sync
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.cartData) {
            window.shopifyCart = event.cartData;
            console.log('window.shopifyCart updated from cartUpdate event:', window.shopifyCart);
          }
        });
      }
      
      connectedCallback() {
        console.log('connectedCallback triggered for product-form element');
        console.log('window.shopifyCart at connectedCallback:', window.shopifyCart ? 'cached' : 'loading/pending');
        // Cart data is now prefetched globally by theme.liquid
        // No need to prefetch again here
        window.addEventListener('pageshow', this.handlePageShow);
      }
      
      prefetchCartData() {
        if (window.shopifyCart) {
          // Cart data already cached, no need to fetch
          return;
        }
        
        // Mark that prefetch is in progress
        window.cartDataLoading = true;
        
        // Prefetch cart data in background
        fetch('/cart.json')
          .then(response => response.json())
          .then(cartData => {
            window.shopifyCart = cartData;
            window.cartDataLoading = false;
            console.log('Cart data prefetched on page load:', cartData);
          })
          .catch(e => {
            window.cartDataLoading = false;
            console.error('Error prefetching cart data:', e);
          });
      }
      
      disconnectedCallback() {
        window.removeEventListener('pageshow', this.handlePageShow);
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Check if product has reached max quantity in cart
        const variantId = this.variantIdInput.value;
        const quantityInput = this.querySelector('[name="quantity"]');
        const quantityToAdd = quantityInput ? parseInt(quantityInput.value) : 1;
        const reservationHandle = 'daisy-one-reservation';
        const productHandle = this.dataset.productHandle || '';
        const isReservationProduct = productHandle === reservationHandle;
        const shouldDirectCheckout = this.dataset.directCheckout === 'true';
        
        // Get maxQuantity from three sources in priority order:
        // 1. From data attribute (Shopify quantity_rule.max)
        // 2. From product limits config file
        // 3. null (no limit)
        // let maxQuantity = quantityInput?.dataset.max ? parseInt(quantityInput.dataset.max) : null;
        
        // // If not found in data attribute, check config file
        // if (maxQuantity === null && productLimitsConfig) {
        //   console.log('maxQuantity not found in data attribute, checking config file...');
        //   const productElement = document.querySelector('[data-product-id]');
        //   const productHandle = productElement?.dataset.productHandle;
        //   const productId = productElement?.dataset.productId;
          
        //   console.log('productElement found:', !!productElement);
        //   console.log('productHandle:', productHandle);
        //   console.log('productId:', productId);
        //   console.log('productLimitsConfig.productLimits:', productLimitsConfig.productLimits);
          
        //   // Look for custom limit in config
        //   if (productLimitsConfig.productLimits?.customLimits) {
        //     console.log('customLimits array:', productLimitsConfig.productLimits.customLimits);
        //     const customLimit = productLimitsConfig.productLimits.customLimits.find(limit => {
        //       console.log('Checking limit:', limit);
        //       const match = (limit.productId && limit.productId == productId) || 
        //                    (limit.productHandle && limit.productHandle === productHandle);
        //       console.log('Match result:', match);
        //       return match;
        //     });
        //     console.log('customLimit found:', customLimit);
        //     if (customLimit && customLimit.maxQuantity !== null) {
        //       maxQuantity = customLimit.maxQuantity;
        //       console.log('maxQuantity from config file:', maxQuantity);
        //     }
        //   }
          
        //   // Use default if still not found
        //   if (maxQuantity === null && productLimitsConfig.productLimits?.default?.maxQuantity !== null) {
        //     maxQuantity = productLimitsConfig.productLimits.default.maxQuantity;
        //   }
        // } else {
        //   console.log('Skipping config file check - maxQuantity:', maxQuantity, 'productLimitsConfig:', !!productLimitsConfig);
        // }
        
        // Get current cart quantity for this variant
        // Use /cart.json API to get real-time cart state (same source as header {{ cart.item_count }})
        const variantIdNum = parseInt(variantId);
        
        // Helper function to proceed with add-to-cart after getting current quantity
        const proceedWithAddToCart = (currentCartQuantity, reservationCartQuantity = 0) => {
          // Reservation product can only be purchased once per cart.
          if (isReservationProduct && reservationCartQuantity + quantityToAdd > 1) {
            this.handleErrorMessage('Reservation limit reached. You can only purchase 1.');
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) cartDrawer.open();
            return;
          }

          // Debug logging
          console.log('=== Add to Bag Debug ===');
          console.log('variantId:', variantId);
          console.log('quantityInput element:', quantityInput);
          console.log('quantityInput.dataset:', quantityInput?.dataset);
          console.log('quantityToAdd:', quantityToAdd);
          // console.log('maxQuantity:', maxQuantity);
          // console.log('currentCartQuantity:', currentCartQuantity);
          // console.log('Check: currentCartQuantity >= maxQuantity?', currentCartQuantity >= (maxQuantity || Infinity));
          
          // If max quantity is set and adding more would exceed it, just open the cart drawer
          // if (maxQuantity !== null && currentCartQuantity >= maxQuantity) {
          //   console.log('Max quantity reached! Opening cart drawer only.');
          //   const cartDrawer = document.querySelector('cart-drawer');
          //   if (cartDrawer) {
          //     cartDrawer.open();
          //   }
          //   this.submitButton.classList.remove('loading');
          //   if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //   const spinner = this.querySelector('.loading__spinner');
          //   if (spinner) spinner.classList.add('hidden');
          //   return;
          // }

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          const spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
          if (this.cart && !shouldDirectCheckout) {
            this.cart.classList.add('is-updating');
          }

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          const reservationAbMetadata = isReservationProduct ? getReservationAbMetadata() : null;
          if (reservationAbMetadata) {
            formData.append('properties[_reservation_ab_test]', reservationAbMetadata.test);
            formData.append('properties[_reservation_ab_variant]', reservationAbMetadata.variant);
            formData.append('properties[_reservation_ab_source]', reservationAbMetadata.source);
          }

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              console.log('Fetch response received:', response);
              console.log('this.cart exists:', !!this.cart);
              
              // Cache the response data for future quantity checks
              if (response.items) {
                window.shopifyCart = response;
                console.log('window.shopifyCart updated from add-to-cart response:', window.shopifyCart);
              }
              
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              }

              if (isReservationProduct && shouldDirectCheckout) {
                console.warn('[ReservationDirectCheckout] redirecting-to-checkout', {
                  variantId: variantId,
                  sourcePath: window.location.pathname
                });
                updateReservationAbCartAttributes(reservationAbMetadata).finally(() => {
                  this.resetLoadingState();
                  window.location.assign('/checkout');
                });
                return;
              }

              if (!this.cart) {
                // Open cart drawer if no cart element found
                console.log('No cart element found. Opening cart drawer.');
                document.querySelector('cart-drawer')?.open();
                return;
              }

              const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                }).then(() => {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                console.log('Rendering cart contents to open drawer.');
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              }
            })
            .catch((e) => {
              console.error(e);
              if (this.cart) this.cart.classList.remove('is-updating');
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              const spinner = this.querySelector('.loading__spinner');
              if (spinner) spinner.classList.add('hidden');

              CartPerformance.measureFromEvent("add:user-action", evt);
            });
        };
        
        // Reservation purchase must be strongly idempotent:
        // always read a fresh cart snapshot to prevent stale-cache double add.
        if (isReservationProduct) {
          fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
            .then((response) => response.json())
            .then((cartData) => {
              window.shopifyCart = cartData;
              const cartItem = (cartData.items || []).find((item) => item.variant_id === variantIdNum);
              const currentCartQuantity = cartItem ? cartItem.quantity : 0;
              const reservationCartQuantity = (cartData.items || [])
                .filter((item) => item.handle === reservationHandle || item.product_handle === reservationHandle)
                .reduce((sum, item) => sum + (item.quantity || 0), 0);
              proceedWithAddToCart.call(this, currentCartQuantity, reservationCartQuantity);
            })
            .catch((e) => {
              console.error('Error fetching fresh /cart.js for reservation check:', e);
              this.handleErrorMessage('Unable to verify cart right now. Please try again.');
            });
          return;
        }

        // For non-reservation products, prefer cached cart for responsiveness.
        if (window.shopifyCart && window.shopifyCart.items && Array.isArray(window.shopifyCart.items)) {
          // Use cached data immediately for instant feedback (no network delay)
          const cartItem = window.shopifyCart.items.find(item => item.variant_id === variantIdNum);
          const currentCartQuantity = cartItem ? cartItem.quantity : 0;
          const reservationCartQuantity = window.shopifyCart.items
            .filter((item) => item.handle === reservationHandle || item.product_handle === reservationHandle)
            .reduce((sum, item) => sum + (item.quantity || 0), 0);
          console.log('Using prefetched cart data, currentCartQuantity:', currentCartQuantity);
          proceedWithAddToCart.call(this, currentCartQuantity, reservationCartQuantity);
        } else {
          // Fallback: fetch cart data if not prefetched or prefetch is still loading
          console.log('Cart data not available or still loading, fetching from /cart.json now...');
          fetch('/cart.json')
            .then(response => response.json())
            .then(cartData => {
              window.shopifyCart = cartData;
              console.log('Cart data fetched from /cart.json:', cartData);
              const cartItem = cartData.items && cartData.items.find(item => item.variant_id === variantIdNum);
              const currentCartQuantity = cartItem ? cartItem.quantity : 0;
              const reservationCartQuantity = (cartData.items || [])
                .filter((item) => item.handle === reservationHandle || item.product_handle === reservationHandle)
                .reduce((sum, item) => sum + (item.quantity || 0), 0);
              proceedWithAddToCart.call(this, currentCartQuantity, reservationCartQuantity);
            })
            .catch(e => {
              console.error('Error fetching /cart.json:', e);
              proceedWithAddToCart.call(this, 0);
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      resetLoadingState() {
        this.submitButton?.classList.remove('loading');
        if (!this.error) this.submitButton?.removeAttribute('aria-disabled');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
        this.cart?.classList.remove('is-updating', 'is-rendering');
        document.body.classList.remove('overflow-hidden');
        document.querySelector('cart-drawer')?.resetDrawerState?.();
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
